let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54odM")).then(() => parcelRequire('2Q69L'));